module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-series.json
// module id = 154
// module chunks = 18604960509584 60335399758886